import React, { useState, useRef } from "react";
import Heart from "../images/heart-lock.svg";
import Constants from "../constants/Constants";
import { navigate } from "@reach/router";
import Sad from "../images/sad.svg";
const PPVItem = ({ ppvid, file, price, udp, dispatch, biller }) => {
  const [isPurchased, SetIsPurchased] = useState(udp === "y");
  const [buyingVideo, setBuyingVideo] = useState(false);
  const [actualVideoID, setActualVideoID] = useState(0);
  const [hasError, setError] = useState(false);
  const [promptConfirm, setPromptConfirm] = useState(false);
  const polling = useRef(null);
  //open up billing page and then if it closes on success switch isPurchasd.
  //in hook I am going to need to make sure if its site_id 0 do some extra shit like marking the messages as udp = y
  const confirmPurchase = () => {
    if (isPurchased) {
      navigate(`${Constants.MA}library`);
      return false;
    }
    setPromptConfirm(true);
  };
  const makePurchase = () => {
    if (isPurchased) {
      navigate(`${Constants.MA}library`);
      return false;
    }
    let newWindow = null;
    if (biller !== 14) {
      newWindow = window.open(
        "https://addfriends.com/robots-working/",
        "_blank"
      );
    }
    setPromptConfirm(false);
    setBuyingVideo(true);

    const formData = new FormData();
    formData.append("videoid", ppvid);
    fetch(`${Constants.API}ips.php`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (!("error" in res)) {
          if ("success" in res) {
            dispatch({
              type: "addLibrary",
              payload: actualVideoID,
            });
            setBuyingVideo(false);
            SetIsPurchased(true);
          } else {
            setActualVideoID(res.x_vid);
            const goTo = `https://wnu.com/secure/services/?api=camcharge&action=authandclose&auth_amount=${res.auth_amount}&member_id=${res.member_id}&returnurl=${res.returnurl}&include_css=${res.include_css}&description=${res.x_description}&pburl=${res.pburl}&x_description=${res.x_description}&x_pkey=${res.x_pkey}&x_vid=${res.x_vid}&epoch_digest=${res.epoch_digest}`;
            newWindow.location = goTo; //This is just the URL sending user too

            startPolling(res.x_pkey, newWindow);
          }
        } else {
          setError(true);
        }
      })
      .catch((error) => console.log(error));
  };
  const startPolling = (tok, newWindow) => {
    let evtSource = new EventSource(`${Constants.API}mjs.php?tok=${tok}`);
    polling.current = evtSource;

    evtSource.onopen = function() {
      console.log("Checking with the 7 about the new site.");
    };

    evtSource.onmessage = function(e) {
      if (e.data === "SUCCESS!") {
        dispatch({
          type: "addLibrary",
          payload: actualVideoID,
        });
        newWindow.close();
        evtSource.close();
        setBuyingVideo(false);
        SetIsPurchased(true);
        // setCloseOffer(true);
        // setIsLibrary(true);
        // setModel({});
      } else if (e.data === "STOP!") {
        newWindow.close();
        evtSource.close();
        setError(true);
      } else {
        console.log("...");
      }
    };

    evtSource.onerror = function() {
      evtSource.close();
      console.log("joined failed.");
      setError(true);
    };
  };
  return (
    <div className="ppvItem" onClick={promptConfirm ? null : confirmPurchase}>
      {isPurchased ? (
        <img
          src={`https://static.addfriends.com/vip/posters/ppv/${file}.jpg`}
          alt=""
        />
      ) : (
        <img
          src={`https://static.addfriends.com/vids/ppv/${file}.jpg`}
          alt=""
        />
      )}
      {isPurchased ? null : (
        <div className="unlockLayer">
          {buyingVideo ? (
            <div className="spinOnPPVImg">
              {hasError ? (
                <div className="sadFaceError">
                  <div className="imgSadPPV">
                    <img src={Sad} alt="There was an error :(" />
                  </div>
                  <p className="errorInfo">
                    Something Happened. Please contact support if you wish to
                    proceed with the purchase of{" "}
                    <strong>PPV item: {ppvid}</strong>.{" "}
                    <a href="https://addfriends.com/contact-us">
                      service@addfriends.com
                    </a>
                  </p>
                </div>
              ) : (
                <div>
                  <div className="nk-spinner activePPV" />{" "}
                  <p style={{ width: "100%", flexShrink: 0 }}>
                    Waiting On Purchase
                  </p>
                </div>
              )}
            </div>
          ) : promptConfirm ? (
            <div className="confirmPurchase">
              <span>Make ${price / 100} Video Purchase?</span>
              <div className="confirmOptions">
                <div className="confirmBTN" onClick={makePurchase}>
                  Yes
                </div>
                <div
                  className="confirmBTN alt"
                  onClick={() => setPromptConfirm(false)}
                >
                  No
                </div>
              </div>
            </div>
          ) : (
            <>
              <img src={Heart} alt="Unlock PPV" />
              <p className="PPVprice">Unlocked For ${price / 100}</p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PPVItem;
